/* Expiry labels.

   Scope is deliberately narrow. In-stock products on the PageFly homepage grid
   are handled entirely by the server-rendered CSS in snippets/expiry-dates.liquid
   — this file must not touch them, or it recreates the duplicate-label bug.

   This script only covers the two cases CSS cannot:
     1. Sold-out products on the homepage grid — PageFly renders no expiry line
        at all, so we insert "Expiry date is not available".
     2. Product pages — insert or restyle the single expiry line.

   Lives in a theme-owned asset because sections/pagefly-home.liquid is
   regenerated by PageFly and loses any Liquid added to it. */
(function () {
  var GREEN = '#28a745';
  var SIX_MONTHS_MS = 15724800000; // 182 days, same window as everywhere else
  var STR = window.__everherExpiryStrings || {};
  var UNAVAILABLE = STR.unavailable || 'Expiry date is not available';
  var PREFIX = STR.prefix || 'Expiry date:';
  var MARK = 'data-everher-expiry';
  var LABEL_CSS =
    'font-size:12px;font-weight:bold;font-style:italic;margin:10px 0;' +
    'text-align:center;line-height:1.35;overflow-wrap:break-word;';

  function normalColour(scope) {
    var probe =
      (scope && scope.querySelector('[data-pf-type="ProductTitle"], .product__title, .card__heading')) ||
      document.body;
    return getComputedStyle(probe).color;
  }

  function fmt(d) {
    function p(n) { return n < 10 ? '0' + n : '' + n; }
    return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear();
  }

  /* Exactly one label per scope: reuse ours if present, never create a second. */
  function ourLabel(scope, anchorFn) {
    var existing = scope.querySelector('[' + MARK + ']');
    if (existing) return existing;

    var el = document.createElement('div');
    el.setAttribute(MARK, '');
    el.style.cssText = LABEL_CSS;

    var anchor = anchorFn && anchorFn(scope);
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(el, anchor);
    } else {
      scope.appendChild(el);
    }
    return el;
  }

  function applyGrid() {
    var data = window.__everherExpiry;
    if (!data) return;

    document.querySelectorAll('[data-pf-type="ProductBox"][data-product-id]').forEach(function (box) {
      var info = data[box.getAttribute('data-product-id')];
      if (!info) return;

      if (info.a !== false) {
        // In stock. If PageFly rendered its own line, leave it alone — the
        // server-rendered CSS colours it. Gulf's regenerated pagefly-home.liquid
        // dropped that block entirely, so fall back to inserting our own.
        var native = Array.prototype.filter.call(
          box.querySelectorAll('div, span, p'),
          function (el) {
            return el.children.length === 0 && /Expiry/i.test(el.textContent) &&
                   !el.hasAttribute(MARK) && el.offsetParent !== null;
          }
        )[0];

        if (native) {
          var stray = box.querySelector('[' + MARK + ']');
          if (stray) stray.remove();
          return;
        }

        if (!info.d) return;
        var bits = info.d.split('-');
        var due = new Date(+bits[0], +bits[1] - 1, +bits[2]);
        if (isNaN(due)) return;

        var own = ourLabel(box, function (s) {
          return s.querySelector('[data-pf-type="ProductATC2"], button[name="add"]');
        });
        var far = due.getTime() > Date.now() + SIX_MONTHS_MS;
        own.textContent = PREFIX + ' ' + fmt(due);
        own.style.color = far ? GREEN : normalColour(box);
        own.setAttribute('data-expiry-state', far ? 'far' : 'near');
        return;
      }

      var label = ourLabel(box, function (s) {
        return s.querySelector('[data-pf-type="ProductATC2"], button[name="add"]');
      });
      label.textContent = UNAVAILABLE;
      label.style.color = normalColour(box);
      label.setAttribute('data-expiry-state', 'unavailable');
    });
  }

  function applyProductPage() {
    var data = window.__everherExpiry;
    var pid = window.__everherProductId;
    if (!data || !pid || !data[pid]) return;

    var scope = document.querySelector('.product__info-container') || document.querySelector('.product');
    if (!scope) return;

    var info = data[pid];
    var text, colour;
    var normal = normalColour(scope);

    if (info.a === false) {
      text = UNAVAILABLE;
      colour = normal;
    } else if (info.d) {
      var b = info.d.split('-');
      var when = new Date(+b[0], +b[1] - 1, +b[2]);
      if (isNaN(when)) return;
      text = PREFIX + ' ' + fmt(when);
      colour = when.getTime() > Date.now() + SIX_MONTHS_MS ? GREEN : normal;
    } else {
      return;
    }

    // Reuse the theme's own "EXP DATE" line if the template renders one.
    var native = Array.prototype.filter.call(
      scope.querySelectorAll('.product__text'),
      function (el) { return /EXP DATE|Expiry/i.test(el.textContent); }
    )[0];

    var label = native || ourLabel(scope, function (s) { return s.querySelector('.price'); });
    label.textContent = text;
    label.style.color = colour;
    label.style.fontWeight = 'bold';
    label.setAttribute('data-expiry-state', info.a === false ? 'unavailable' : (colour === GREEN ? 'far' : 'near'));
  }

  function apply() {
    applyGrid();
    applyProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', function () { setTimeout(apply, 600); });
})();
